export const EDITABLE_DD_MODES = {
    ALL: 0,
    TEXT_ONLY: 1,
    LIST_ONLY: 2
};
